import { motion, type HTMLMotionProps } from 'framer-motion';

const defaultAnimation: Pick<
  HTMLMotionProps<'div'>,
  'initial' | 'animate' | 'exit' | 'transition'
> = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.2, ease: 'easeOut' },
};

interface AnimatedContainerProps extends HTMLMotionProps<'div'> {
  className?: string;
}

export const AnimatedContainer = ({
  className,
  children,
  initial = defaultAnimation.initial,
  animate = defaultAnimation.animate,
  exit = defaultAnimation.exit,
  transition = defaultAnimation.transition,
  ...props
}: AnimatedContainerProps): React.ReactElement => (
  <motion.div
    initial={initial}
    animate={animate}
    exit={exit}
    transition={transition}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);
